/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { faqControllerCreate } from '../fn/fa-qs/faq-controller-create';
import { FaqControllerCreate$Params } from '../fn/fa-qs/faq-controller-create';
import { faqControllerDelete } from '../fn/fa-qs/faq-controller-delete';
import { FaqControllerDelete$Params } from '../fn/fa-qs/faq-controller-delete';
import { faqControllerFindById } from '../fn/fa-qs/faq-controller-find-by-id';
import { FaqControllerFindById$Params } from '../fn/fa-qs/faq-controller-find-by-id';
import { faqControllerSearch } from '../fn/fa-qs/faq-controller-search';
import { FaqControllerSearch$Params } from '../fn/fa-qs/faq-controller-search';
import { faqControllerToggleExpose } from '../fn/fa-qs/faq-controller-toggle-expose';
import { FaqControllerToggleExpose$Params } from '../fn/fa-qs/faq-controller-toggle-expose';
import { faqControllerTogglePin } from '../fn/fa-qs/faq-controller-toggle-pin';
import { FaqControllerTogglePin$Params } from '../fn/fa-qs/faq-controller-toggle-pin';
import { faqControllerUpdate } from '../fn/fa-qs/faq-controller-update';
import { FaqControllerUpdate$Params } from '../fn/fa-qs/faq-controller-update';
import { FaqDto } from '../models/faq-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class FaQsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `faqControllerSearch()` */
  static readonly FaqControllerSearchPath = '/api/faqs';

  /**
   * FAQ 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerSearch$Response(params: FaqControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = faqControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerSearch(params: FaqControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.faqControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `faqControllerCreate()` */
  static readonly FaqControllerCreatePath = '/api/faqs';

  /**
   * FAQ 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqControllerCreate$Response(params: FaqControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqControllerCreate(params: FaqControllerCreate$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqControllerFindById()` */
  static readonly FaqControllerFindByIdPath = '/api/faqs/{id}';

  /**
   * FAQ 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerFindById$Response(params: FaqControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerFindById(params: FaqControllerFindById$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqControllerDelete()` */
  static readonly FaqControllerDeletePath = '/api/faqs/{id}';

  /**
   * FAQ 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerDelete$Response(params: FaqControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerDelete(params: FaqControllerDelete$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqControllerUpdate()` */
  static readonly FaqControllerUpdatePath = '/api/faqs/{id}';

  /**
   * FAQ 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqControllerUpdate$Response(params: FaqControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  faqControllerUpdate(params: FaqControllerUpdate$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqControllerToggleExpose()` */
  static readonly FaqControllerToggleExposePath = '/api/faqs/{id}/toggle-expose';

  /**
   * FAQ 노출/비노출 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerToggleExpose()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerToggleExpose$Response(params: FaqControllerToggleExpose$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqControllerToggleExpose(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 노출/비노출 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerToggleExpose$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerToggleExpose(params: FaqControllerToggleExpose$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqControllerToggleExpose$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

  /** Path part for operation `faqControllerTogglePin()` */
  static readonly FaqControllerTogglePinPath = '/api/faqs/{id}/toggle-pin';

  /**
   * FAQ 고정/비고정 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqControllerTogglePin()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerTogglePin$Response(params: FaqControllerTogglePin$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqControllerTogglePin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 고정/비고정 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqControllerTogglePin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqControllerTogglePin(params: FaqControllerTogglePin$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqControllerTogglePin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

}
